
    <mat-paginator [length]="dataSource.data.length" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
      aria-label="Select page of periodic elements"></mat-paginator>
    <mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef>Date Modified</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.ChangedDate }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="modified">
        <mat-header-cell *matHeaderCellDef>Modified By</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.ChangedBy }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="field">
        <mat-header-cell *matHeaderCellDef>Field</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ getFieldName(element.ChangedField) }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="previousValue">
        <mat-header-cell *matHeaderCellDef>Previous Value</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.ChangedValue }}</mat-cell>
      </ng-container>      

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" ></mat-row>
    </mat-table>
